import template from './languageSelector.html';
import controller from './languageSelector.controller';

function languageSelectorDirective() {
  return {
          restrict: 'AEC',
          replace: true,
          scope: {},
          template,
          controller,
          controllerAs: 'vm',
          link: function (scope) {
            scope.name = 'Foo';
          }
  }
}
export default languageSelectorDirective;



// WEBPACK FOOTER //
// ./client/app/common/languageSelector/languageSelector.directive.js